<button (click)="showPrintSettingsModal()" color="primary" mat-stroked-button>Print settings</button>
